import React, { Fragment } from 'react';
import Card from '../Card/Card';

function LeftSideAbout() {
  return (
    <Fragment>
      <Card
        title='فريق عمل متكامل'
        AiOutlineTeamIcon
        description='فريق قائم بذاته ومستقل يعمل بشكل جماعي بجميع المهارات اللازمة لإنجاز
العمل بأعلى كفاءة وفي الوقت المحدد.'
      />

      <Card
        title='المرونة'
        AiOutlineSafetyIcon
        description='لدينا القدرة على التكيف مع التغيير قصير المدى بسرعة وهدوء ، بحيث
يمكننا التعامل مع المشاكل أو المهام غير المتوقعة بشكل سريع وفعال.'
      />

      <Card
        title='الجودة'
        AiOutlineAntDesignIcon
        description='نعمل على تحسين الإنتاجية وتوسيع نطاق العمل وضمان استمراره لتحقيق الإنجاز في الموعد المحدد وتقديم معلومات ونتائج دقيقة.'
      />

      <Card
        title='المصداقية'
        AiOutlineCodeIcon
        description='نعمل على كسب ثقة العملاء من خلال الدعم الذي نقدمه عند إطلاق أي منتج أو خدمة جديدة بالإضافة إلى تقديم النقد البناء عندما تحتاج لتطوير عملك.'
      />
    </Fragment>
  );
}

export default LeftSideAbout;
